import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "troubleshoot-classifications-api"
    }}>{`Troubleshoot Classifications API`}</h1>
    <p>{`Reference this page if you encounter issues when using the classifications API. Common status codes and troubleshooting steps are provided.`}</p>
    <h2 {...{
      "id": "api-status-codes"
    }}>{`API status codes`}</h2>
    <p>{`Many classification API issues can be identified in the API response. See the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/landing/troubleshooting.html"
      }}>{`FAQ and troubleshooting guide`}</a>{` in the Experience Platform API documentation. The Classifications API and the Experience Platform API share the root URI domain of `}<inlineCode parentName="p">{`adobe.io`}</inlineCode>{`, so all status code messages are shared.`}</p>
    <p>{`If you are unable to decipher the error messages or status codes returned from the Classification API, contact Adobe Customer Care. When contacting Adobe, provide the agent with the following information:`}</p>
    <ul>
      <li parentName="ul">{`The API request, preferably in curl format. Authentication headers can be omitted.`}</li>
      <li parentName="ul">{`The response from the Classification API, typically in text or JSON format.`}</li>
    </ul>
    <p>{`Customer Care can validate the API request issue and escalate to engineering if needed.`}</p>
    <h2 {...{
      "id": "troubleshoot-classification-data"
    }}>{`Troubleshoot classification data`}</h2>
    <p>{`If you receive successful API responses but see issues within the classification data itself, log in to Adobe Analytics and perform a manual browser export of the data. Observe each value in the downloaded file to see if it matches with expected classification data.`}</p>
    <ul>
      <li parentName="ul">{`If classification data is incorrect, attempt a manual browser upload that corrects the keys in question.`}</li>
      <li parentName="ul">{`If classification data is correct, wait 48 hours to make sure that classified values have had the opportunity to propagate to all servers processing your data.`}</li>
      <li parentName="ul">{`If you still see issues with classification data, contact Adobe Customer Care and include the following information:`}
        <ul parentName="li">
          <li parentName="ul">{`The report suite`}</li>
          <li parentName="ul">{`The dimension in question`}</li>
          <li parentName="ul">{`Specific example keys with incorrect values`}</li>
        </ul>
      </li>
    </ul>
    <p>{`Customer care can validate the classification inconsistencies that you see and escalate to engineering if needed.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      